/* ==========================================================================
   Royal Care Professional — countdown bar

   One ticker for the whole page, not one per bar. It wakes once a second,
   asks each bar what it should read, and writes only the digits that actually
   changed — so a normal second costs four string compares and, at most, one
   textContent write. When no bar is left running it clears itself.

   Two ways to set the deadline:

   - fixed     the section stamps an absolute epoch into the markup, so full
               page caching cannot stale it and every visitor sees the same
               deadline.
   - evergreen each visitor gets their own window, opened on first view and
               remembered in localStorage.
   ========================================================================== */

(function () {
  'use strict';

  if (window.RCCountdown) {
    window.RCCountdown.init();
    return;
  }

  var UNITS = ['days', 'hours', 'mins', 'secs'];

  /* localStorage is unavailable in some privacy modes; never let it throw. */
  function readStore(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function writeStore(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* no-op */ }
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function Bar(root) {
    this.root = root;
    this.mode = root.dataset.mode || 'fixed';
    this.onEnd = root.dataset.onEnd || 'hide';
    this.storageKey = root.dataset.storageKey || '';

    this.nodes = {};
    for (var i = 0; i < UNITS.length; i++) {
      this.nodes[UNITS[i]] = root.querySelector('[data-rc-cd-' + UNITS[i] + ']');
    }

    // Remembering the last written string is what keeps the tick cheap.
    this.last = {};
    this.done = false;
    this.deadline = this.resolveDeadline();
  }

  /*
   * Fixed bars carry their deadline in the markup. Evergreen bars open their
   * window on first view and store it, so a returning visitor keeps counting
   * down rather than starting over.
   */
  Bar.prototype.resolveDeadline = function () {
    if (this.mode === 'evergreen') {
      var hours = parseFloat(this.root.dataset.hours) || 24;
      var stored = parseInt(readStore(this.storageKey + '-ends'), 10);
      var now = Date.now();

      if (stored && stored > now) return stored;

      // Either the first visit or a window that has already run out: reopen it.
      var ends = now + hours * 3600000;
      writeStore(this.storageKey + '-ends', String(ends));
      return ends;
    }

    var ts = parseInt(this.root.dataset.endsAt, 10);
    return ts ? ts * 1000 : 0;
  };

  Bar.prototype.write = function (unit, value) {
    if (this.last[unit] === value) return;
    this.last[unit] = value;
    var node = this.nodes[unit];
    if (node) node.textContent = value;
  };

  /* Returns true while the bar still needs ticking. */
  Bar.prototype.tick = function (now) {
    if (this.done) return false;

    var left = this.deadline - now;

    if (left <= 0) {
      this.finish();
      return false;
    }

    var total = Math.floor(left / 1000);
    this.write('days', pad(Math.floor(total / 86400)));
    this.write('hours', pad(Math.floor(total / 3600) % 24));
    this.write('mins', pad(Math.floor(total / 60) % 60));
    this.write('secs', pad(total % 60));
    return true;
  };

  Bar.prototype.finish = function () {
    this.done = true;

    if (this.onEnd === 'hide') {
      this.root.classList.add('rc-cd--hidden');
      return;
    }

    // 'zeros' — leave the bar in place, reading all zeros.
    for (var i = 0; i < UNITS.length; i++) this.write(UNITS[i], '00');
  };

  Bar.prototype.dismiss = function () {
    this.root.classList.add('rc-cd--hidden');
    this.done = true;
    if (this.storageKey) writeStore(this.storageKey + '-closed', '1');
  };

  Bar.prototype.bind = function () {
    var self = this;
    var close = this.root.querySelector('[data-rc-cd-close]');
    if (close) {
      close.addEventListener('click', function () { self.dismiss(); });
    }
  };

  /* ---- the shared ticker ---- */

  var bars = [];
  var timer = 0;

  function pump() {
    var now = Date.now();
    var live = [];

    for (var i = 0; i < bars.length; i++) {
      if (bars[i].tick(now)) live.push(bars[i]);
    }

    bars = live;

    if (!bars.length && timer) {
      clearInterval(timer);
      timer = 0;
    }
  }

  function add(bar) {
    // One synchronous tick so the bar is correct before the first interval.
    if (!bar.tick(Date.now())) return;
    bars.push(bar);
    if (!timer) timer = setInterval(pump, 1000);
  }

  var RCCountdown = {
    init: function (root) {
      var scope = root || document;

      Array.prototype.forEach.call(scope.querySelectorAll('[data-rc-cd]'), function (el) {
        if (el.dataset.rcCdReady === 'true') return;
        el.dataset.rcCdReady = 'true';

        var bar = new Bar(el);

        // A bar the visitor already closed never becomes visible.
        if (bar.storageKey && readStore(bar.storageKey + '-closed') === '1') {
          el.classList.add('rc-cd--hidden');
          return;
        }

        bar.bind();
        add(bar);
      });
    }
  };

  window.RCCountdown = RCCountdown;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { RCCountdown.init(); });
  } else {
    RCCountdown.init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    RCCountdown.init(event.target);
  });
})();
